/**
 * A MoTeC ECU does nothing without a firmware package, so the cart must not
 * reach checkout with an ECU and no package in it. Packages on their own are
 * fine - people buy them for hardware they already own.
 *
 * Plug-and-play kits are exempt: a kit line item already bundles its package,
 * and one of them ("RAV Nissan S15 Silvia MoTeC M130 PNP Kit") is typed ECU,
 * so type alone would wrongly demand a second package alongside it.
 *
 * Configuration comes from window.RAV_LICENSE_GUARD, set in the Liquid snippet
 * so the wording can be changed without touching this file.
 *
 * This is a storefront guard, not a security boundary. It covers every path a
 * real customer takes; it cannot stop a hand-crafted POST to /checkout. Only a
 * Shopify cart-validation function can do that.
 */
(function () {
  'use strict';

  var CFG = window.RAV_LICENSE_GUARD || {};
  var ECU_TYPE = CFG.ecuType || 'ECU';
  var LICENSE_TYPE = CFG.licenseType || 'ECU Packages';
  var MESSAGE = CFG.message ||
    'MoTeC ECUs need a firmware package to run. Add the package for your ' +
    'application before checking out.';
  var LINK_TEXT = CFG.linkText || 'Browse MoTeC packages';
  var LINK_URL = CFG.linkUrl || '/collections/motec';
  // product_type 'ECU' is NOT MoTeC-only - it also holds the Link ECU range and
  // will hold Haltech. Those are complete units that take no MoTeC licence, so
  // the rule must be scoped by vendor or it makes them unsellable.
  // Matched case-insensitively: 6 MoTeC products still carry the old 'MoTec'
  // spelling, and an exact match would let those escape the rule entirely.
  var VENDOR = new RegExp(CFG.ecuVendorPattern || 'motec', 'i');

  var KIT = /\bkits?\b/i;
  var NOTICE_CLASS = 'license-guard-notice';
  var ok = true;
  var applyTimer = null;

  function isKit(item) {
    // product_title is the parent product's title; item.title includes the
    // variant and would also match, but the parent is the honest signal.
    return KIT.test(item.product_title || item.title || '');
  }

  function evaluate(cart) {
    var items = (cart && cart.items) || [];
    var needs = false;
    var has = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var mine = VENDOR.test(it.vendor || '');
      if (it.product_type === ECU_TYPE && mine && !isKit(it)) needs = true;
      // A kit typed ECU Packages is hardware (C127 Track Kit and the like)
      // and carries no firmware, so it cannot satisfy a bare ECU's need.
      // Vendor-scoped for the same reason: a non-MoTeC bundle filed under
      // ECU Packages must not silently satisfy a MoTeC ECU either.
      if (it.product_type === LICENSE_TYPE && mine && !isKit(it)) has = true;
    }
    return !needs || has;
  }

  function injectStyles() {
    if (document.getElementById('license-guard-styles')) return;
    var s = document.createElement('style');
    s.id = 'license-guard-styles';
    s.textContent =
      '.' + NOTICE_CLASS + '{margin:0 0 .75rem;padding:.75rem .9rem;' +
      'border:1px solid currentColor;border-radius:.4rem;font-size:.9rem;' +
      'line-height:1.4;opacity:.95}' +
      '.' + NOTICE_CLASS + ' a{text-decoration:underline}' +
      'button[name="checkout"][disabled]{opacity:.5;cursor:not-allowed}';
    document.head.appendChild(s);
  }

  function noticeFor(button) {
    var host = button.parentNode;
    if (!host) return null;
    var existing = host.querySelector(':scope > .' + NOTICE_CLASS);
    if (existing) return existing;
    var el = document.createElement('div');
    el.className = NOTICE_CLASS;
    el.setAttribute('role', 'status');
    el.innerHTML = '';
    host.insertBefore(el, button);
    return el;
  }

  function apply() {
    injectStyles();

    var buttons = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      // Never re-enable a button the theme disabled for its own reason - an
      // empty cart already disables it, and we must not override that.
      if (b.dataset.licenseGuard !== '1' && b.disabled) continue;
      b.dataset.licenseGuard = '1';
      b.disabled = !ok;
      if (ok) {
        b.removeAttribute('aria-describedby');
      }
      var n = noticeFor(b);
      if (n) {
        n.hidden = ok;
        if (!ok && !n.dataset.filled) {
          n.innerHTML = '';
          n.appendChild(document.createTextNode(MESSAGE + ' '));
          var a = document.createElement('a');
          a.href = LINK_URL;
          a.textContent = LINK_TEXT;
          n.appendChild(a);
          n.dataset.filled = '1';
        }
      }
    }

    // Accelerated checkout buttons post straight to Shopify and never touch the
    // cart form, so hiding them is the only way to keep them out of the flow.
    var extra = document.querySelectorAll(
      '.cart-dynamic-checkout-buttons, .additional-checkout-buttons');
    for (var j = 0; j < extra.length; j++) {
      extra[j].style.display = ok ? '' : 'none';
    }
  }

  function refresh() {
    return fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { ok = evaluate(cart); apply(); })
      .catch(function () { /* leave checkout usable if the cart cannot be read */ });
  }

  function scheduleApply() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(apply, 60);
  }

  // Hard stop: the cart form submits with the checkout button as submitter.
  // Quantity updates submit the same form, so only the checkout path is caught.
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (!ok && s && s.name === 'checkout') {
      e.preventDefault();
      e.stopPropagation();
      var n = document.querySelector('.' + NOTICE_CLASS);
      if (n) n.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);

  function start() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      subscribe(PUB_SUB_EVENTS.cartItemAdd, refresh);
    }
    document.addEventListener('mini-cart:opened', refresh);
    // Cart sections are replaced wholesale on update, taking the notice and the
    // disabled flag with them; re-apply the known state when that happens.
    if (window.MutationObserver) {
      new MutationObserver(scheduleApply).observe(document.body,
        { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
